export var mockHours = [{
  pickupOpen: "12:00",
  pickupClose: "20:45",
  deliveryOpen: "12:00",
  deliveryClose: "20:45",
  dineInOpen: "12:00",
  dineInClose: "21:00",
  day: 1
}, {
  pickupOpen: "12:00",
  pickupClose: "20:45",
  deliveryOpen: "12:00",
  deliveryClose: "20:45",
  dineInOpen: "12:00",
  dineInClose: "21:00",
  day: 2
}, {
  pickupOpen: "12:00",
  pickupClose: "20:45",
  deliveryOpen: "12:00",
  deliveryClose: "20:45",
  dineInOpen: "12:00",
  dineInClose: "21:00",
  day: 3
}, {
  pickupOpen: "12:00",
  pickupClose: "20:45",
  deliveryOpen: "12:00",
  deliveryClose: "20:45",
  dineInOpen: "12:00",
  dineInClose: "21:00",
  day: 4
}, {
  pickupOpen: "12:00",
  pickupClose: "20:45",
  deliveryOpen: "12:00",
  deliveryClose: "20:45",
  dineInOpen: "12:00",
  dineInClose: "21:00",
  day: 5
}, {
  pickupOpen: "11:00",
  pickupClose: "20:45",
  deliveryOpen: "11:00",
  deliveryClose: "20:45",
  dineInOpen: "11:00",
  dineInClose: "21:00",
  day: 6
}, {
  pickupOpen: "11:00",
  pickupClose: "20:45",
  deliveryOpen: "11:00",
  deliveryClose: "20:45",
  dineInOpen: "11:00",
  dineInClose: "21:00",
  day: 0
}];
export var mockRestaurantGroups = [{
  cuisine: "",
  description: "",
  _id: "60e5c6f45e7ea60013bbaf6a",
  name: "BurgerFi",
  media: {
    restaurantBanner: "https://images.lunchbox.io/restaurant-groups/burgerfisuperior/production/6137cb31a6c09a0014a036aa/c8cf1a85-2976-4459-8e20-e6169d072f7c-1631046449385.jpeg",
    restaurantIcon: "https://images.lunchbox.io/restaurant-groups/burgerfisuperior/production/614e6abfd2e6400013873ecb/8e46fe53-cb5a-49cb-928e-b535c8236c4c-1632529087826.png",
    restaurantLogo: "https://images.lunchbox.io/restaurant-groups/burgerfisuperior/production/614e6abfd2e6400013873ecb/8e46fe53-cb5a-49cb-928e-b535c8236c4c-1632529087826.png",
    restaurantSelectedIcon: "https://images.lunchbox.io/restaurant-groups/burgerfisuperior/production/614e6abfd2e6400013873ecb/8e46fe53-cb5a-49cb-928e-b535c8236c4c-1632529087826.png",
    restaurantThumbnail: "https://images.lunchbox.io/restaurant-groups/burgerfisuperior/production/6137ca1c88e530001295feb5/83748fee-a313-4c6e-999e-0a0883f66bb8-1631046172622.jpeg",
    restaurantUnselectedIcon: "https://images.lunchbox.io/restaurant-groups/burgerfisuperior/production/614e6abfd2e6400013873ecb/8e46fe53-cb5a-49cb-928e-b535c8236c4c-1632529087826.png"
  },
  id: "60e5c6f45e7ea60013bbaf6a"
}, {
  cuisine: "",
  description: "",
  _id: "61294c0cd231790014ba9a66",
  name: "Blue Ribbon Fried Chicken",
  media: {
    restaurantBanner: "https://images.lunchbox.io/restaurant-groups/blueribbon/production/6137cc86cef7110012b7cf50/69877ae2-f001-401b-bd7a-80e161cd109d-1631046790226.jpeg",
    restaurantIcon: "https://images.lunchbox.io/restaurant-groups/blueribbon/production/614e6a65d2e6400013873ac6/d72bb86d-cad8-4fb7-922f-56513ca49df0-1632528997021.png",
    restaurantLogo: "https://images.lunchbox.io/restaurant-groups/blueribbon/production/614e6a65d2e6400013873ac6/d72bb86d-cad8-4fb7-922f-56513ca49df0-1632528997021.png",
    restaurantSelectedIcon: "https://images.lunchbox.io/restaurant-groups/blueribbon/production/614e6a65d2e6400013873ac6/d72bb86d-cad8-4fb7-922f-56513ca49df0-1632528997021.png",
    restaurantThumbnail: "https://images.lunchbox.io/restaurant-groups/blueribbon/production/6137cc86cef7110012b7cf50/69877ae2-f001-401b-bd7a-80e161cd109d-1631046790226.jpeg",
    restaurantUnselectedIcon: "https://images.lunchbox.io/restaurant-groups/blueribbon/production/614e6a65d2e6400013873ac6/d72bb86d-cad8-4fb7-922f-56513ca49df0-1632528997021.png"
  },
  id: "61294c0cd231790014ba9a66"
}, {
  cuisine: "",
  description: "",
  _id: "61294d09d231790014ba9b03",
  name: "800\xB0 Degrees Pizza",
  media: {
    restaurantBanner: "https://images.lunchbox.io/restaurant-groups/800degreego/production/6137c9e3a6c09a0014a0352d/9469c1cb-9b63-493d-8226-e422f5727d72-1631046115963.jpeg",
    restaurantIcon: "https://images.lunchbox.io/restaurant-groups/800degreego/production/615c7ffe6b67a600122ceefb/44697abe-da56-40ef-aa57-c5bd777754a3-1633452030257.png",
    restaurantLogo: "https://images.lunchbox.io/restaurant-groups/800degreego/production/615c7ffe6b67a600122ceefb/44697abe-da56-40ef-aa57-c5bd777754a3-1633452030257.png",
    restaurantSelectedIcon: "https://images.lunchbox.io/restaurant-groups/800degreego/production/615c7ffe6b67a600122ceefb/44697abe-da56-40ef-aa57-c5bd777754a3-1633452030257.png",
    restaurantThumbnail: "https://images.lunchbox.io/restaurant-groups/800degreego/production/6137c9e3a6c09a0014a0352d/9469c1cb-9b63-493d-8226-e422f5727d72-1631046115963.jpeg",
    restaurantUnselectedIcon: "https://images.lunchbox.io/restaurant-groups/800degreego/production/615c7ffe6b67a600122ceefb/44697abe-da56-40ef-aa57-c5bd777754a3-1633452030257.png"
  },
  id: "61294d09d231790014ba9b03"
}, {
  cuisine: "",
  description: "",
  _id: "612d065118820700126d4486",
  name: "Pokeworks",
  media: {
    restaurantBanner: "https://images.lunchbox.io/restaurant-groups/pokeworks/production/6137c9baa6c09a0014a03500/fe9df3d2-4156-4b12-8835-ae84ec118a44-1631046074294.jpeg",
    restaurantIcon: "https://images.lunchbox.io/restaurant-groups/pokeworks/production/614e6a88d27bad00137390f8/36e902d8-d629-463c-b541-139a1db6172b-1632529032882.png",
    restaurantLogo: "https://images.lunchbox.io/restaurant-groups/pokeworks/production/614e6a88d27bad00137390f8/36e902d8-d629-463c-b541-139a1db6172b-1632529032882.png",
    restaurantSelectedIcon: "https://images.lunchbox.io/restaurant-groups/pokeworks/production/614e6a88d27bad00137390f8/36e902d8-d629-463c-b541-139a1db6172b-1632529032882.png",
    restaurantThumbnail: "https://images.lunchbox.io/restaurant-groups/pokeworks/production/6137c9baa6c09a0014a03500/fe9df3d2-4156-4b12-8835-ae84ec118a44-1631046074294.jpeg",
    restaurantUnselectedIcon: "https://images.lunchbox.io/restaurant-groups/pokeworks/production/614e6a88d27bad00137390f8/36e902d8-d629-463c-b541-139a1db6172b-1632529032882.png"
  },
  id: "612d065118820700126d4486"
}, {
  cuisine: "",
  description: "",
  _id: "60e5c6f45e7ea60013bbaf6a",
  name: "BurgerFi",
  media: {
    restaurantBanner: "https://images.lunchbox.io/restaurant-groups/burgerfisuperior/production/6137cb31a6c09a0014a036aa/c8cf1a85-2976-4459-8e20-e6169d072f7c-1631046449385.jpeg",
    restaurantIcon: "https://images.lunchbox.io/restaurant-groups/burgerfisuperior/production/614e6abfd2e6400013873ecb/8e46fe53-cb5a-49cb-928e-b535c8236c4c-1632529087826.png",
    restaurantLogo: "https://images.lunchbox.io/restaurant-groups/burgerfisuperior/production/614e6abfd2e6400013873ecb/8e46fe53-cb5a-49cb-928e-b535c8236c4c-1632529087826.png",
    restaurantSelectedIcon: "https://images.lunchbox.io/restaurant-groups/burgerfisuperior/production/614e6abfd2e6400013873ecb/8e46fe53-cb5a-49cb-928e-b535c8236c4c-1632529087826.png",
    restaurantThumbnail: "https://images.lunchbox.io/restaurant-groups/burgerfisuperior/production/6137ca1c88e530001295feb5/83748fee-a313-4c6e-999e-0a0883f66bb8-1631046172622.jpeg",
    restaurantUnselectedIcon: "https://images.lunchbox.io/restaurant-groups/burgerfisuperior/production/614e6abfd2e6400013873ecb/8e46fe53-cb5a-49cb-928e-b535c8236c4c-1632529087826.png"
  },
  id: "60e5c6f45e7ea60013bbaf6a"
}, {
  cuisine: "",
  description: "",
  _id: "61294c0cd231790014ba9a66",
  name: "Blue Ribbon Fried Chicken",
  media: {
    restaurantBanner: "https://images.lunchbox.io/restaurant-groups/blueribbon/production/6137cc86cef7110012b7cf50/69877ae2-f001-401b-bd7a-80e161cd109d-1631046790226.jpeg",
    restaurantIcon: "https://images.lunchbox.io/restaurant-groups/blueribbon/production/614e6a65d2e6400013873ac6/d72bb86d-cad8-4fb7-922f-56513ca49df0-1632528997021.png",
    restaurantLogo: "https://images.lunchbox.io/restaurant-groups/blueribbon/production/614e6a65d2e6400013873ac6/d72bb86d-cad8-4fb7-922f-56513ca49df0-1632528997021.png",
    restaurantSelectedIcon: "https://images.lunchbox.io/restaurant-groups/blueribbon/production/614e6a65d2e6400013873ac6/d72bb86d-cad8-4fb7-922f-56513ca49df0-1632528997021.png",
    restaurantThumbnail: "https://images.lunchbox.io/restaurant-groups/blueribbon/production/6137cc86cef7110012b7cf50/69877ae2-f001-401b-bd7a-80e161cd109d-1631046790226.jpeg",
    restaurantUnselectedIcon: "https://images.lunchbox.io/restaurant-groups/blueribbon/production/614e6a65d2e6400013873ac6/d72bb86d-cad8-4fb7-922f-56513ca49df0-1632528997021.png"
  },
  id: "61294c0cd231790014ba9a66"
}, {
  cuisine: "",
  description: "",
  _id: "61294d09d231790014ba9b03",
  name: "800\xB0 Degrees Pizza",
  media: {
    restaurantBanner: "https://images.lunchbox.io/restaurant-groups/800degreego/production/6137c9e3a6c09a0014a0352d/9469c1cb-9b63-493d-8226-e422f5727d72-1631046115963.jpeg",
    restaurantIcon: "https://images.lunchbox.io/restaurant-groups/800degreego/production/615c7ffe6b67a600122ceefb/44697abe-da56-40ef-aa57-c5bd777754a3-1633452030257.png",
    restaurantLogo: "https://images.lunchbox.io/restaurant-groups/800degreego/production/615c7ffe6b67a600122ceefb/44697abe-da56-40ef-aa57-c5bd777754a3-1633452030257.png",
    restaurantSelectedIcon: "https://images.lunchbox.io/restaurant-groups/800degreego/production/615c7ffe6b67a600122ceefb/44697abe-da56-40ef-aa57-c5bd777754a3-1633452030257.png",
    restaurantThumbnail: "https://images.lunchbox.io/restaurant-groups/800degreego/production/6137c9e3a6c09a0014a0352d/9469c1cb-9b63-493d-8226-e422f5727d72-1631046115963.jpeg",
    restaurantUnselectedIcon: "https://images.lunchbox.io/restaurant-groups/800degreego/production/615c7ffe6b67a600122ceefb/44697abe-da56-40ef-aa57-c5bd777754a3-1633452030257.png"
  },
  id: "61294d09d231790014ba9b03"
}, {
  cuisine: "",
  description: "",
  _id: "612d065118820700126d4486",
  name: "Pokeworks",
  media: {
    restaurantBanner: "https://images.lunchbox.io/restaurant-groups/pokeworks/production/6137c9baa6c09a0014a03500/fe9df3d2-4156-4b12-8835-ae84ec118a44-1631046074294.jpeg",
    restaurantIcon: "https://images.lunchbox.io/restaurant-groups/pokeworks/production/614e6a88d27bad00137390f8/36e902d8-d629-463c-b541-139a1db6172b-1632529032882.png",
    restaurantLogo: "https://images.lunchbox.io/restaurant-groups/pokeworks/production/614e6a88d27bad00137390f8/36e902d8-d629-463c-b541-139a1db6172b-1632529032882.png",
    restaurantSelectedIcon: "https://images.lunchbox.io/restaurant-groups/pokeworks/production/614e6a88d27bad00137390f8/36e902d8-d629-463c-b541-139a1db6172b-1632529032882.png",
    restaurantThumbnail: "https://images.lunchbox.io/restaurant-groups/pokeworks/production/6137c9baa6c09a0014a03500/fe9df3d2-4156-4b12-8835-ae84ec118a44-1631046074294.jpeg",
    restaurantUnselectedIcon: "https://images.lunchbox.io/restaurant-groups/pokeworks/production/614e6a88d27bad00137390f8/36e902d8-d629-463c-b541-139a1db6172b-1632529032882.png"
  },
  id: "612d065118820700126d4486"
}];
export default {
  location: {
    address: {
      city: "Denver",
      state: "CO",
      street1: "1890 S. Pearl St.",
      zip: "80210"
    },
    distanceInMiles: 0.4,
    estimatedTime: "20-25 min",
    hours: mockHours,
    isOpen: true,
    name: "Fort Lauderdale",
    phoneNumber: "720.242.9551",
    restaurantGroups: mockRestaurantGroups
  }
};